import { render, staticRenderFns } from "./portrait-data.vue?vue&type=template&id=26411815&scoped=true&"
import script from "./portrait-data.vue?vue&type=script&lang=js&"
export * from "./portrait-data.vue?vue&type=script&lang=js&"
import style0 from "./portrait-data.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./portrait-data.vue?vue&type=style&index=1&id=26411815&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26411815",
  null
  
)

export default component.exports